import { useState } from "react";
import ReactLoading from "react-loading"
type propsType = {
    disp: boolean;
}

const Loading = (props: propsType) => {

    console.log("Props:" + props.disp)
    return (
        <div>
        { props.disp && <><ReactLoading
                type="spin"
                color="black"
                height="100px"
                width="100px"
                className="mx-auto" /><p className="text-center mt-3">DeviceIDを取得中・・・</p></>

            
        }
        
         </div>
        
    )
   
}
export default Loading